/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ThemeTestRouteImport } from './routes/theme-test'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as GuestRouteImport } from './routes/_guest'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as GuestSignupRouteImport } from './routes/_guest/signup'
import { Route as GuestResetPasswordRouteImport } from './routes/_guest/reset-password'
import { Route as GuestLoginRouteImport } from './routes/_guest/login'
import { Route as GuestForgotPasswordRouteImport } from './routes/_guest/forgot-password'
import { Route as AuthenticatedMallIdRouteImport } from './routes/_authenticated/$mallId'
import { Route as AuthenticatedMallIdIndexRouteImport } from './routes/_authenticated/$mallId/index'
import { Route as AuthenticatedMallIdSettingsRouteImport } from './routes/_authenticated/$mallId/settings'
import { Route as AuthenticatedMallIdReleaseNotesRouteImport } from './routes/_authenticated/$mallId/release-notes'
import { Route as AuthenticatedMallIdSupportIndexRouteImport } from './routes/_authenticated/$mallId/support/index'
import { Route as AuthenticatedMallIdCouponIndexRouteImport } from './routes/_authenticated/$mallId/coupon/index'
import { Route as AuthenticatedMallIdBillingIndexRouteImport } from './routes/_authenticated/$mallId/billing/index'
import { Route as AuthenticatedMallIdAutomationIndexRouteImport } from './routes/_authenticated/$mallId/automation/index'
import { Route as AuthenticatedMallIdSupportInquiryIdRouteImport } from './routes/_authenticated/$mallId/support/$inquiryId'
import { Route as AuthenticatedMallIdCouponNewRouteImport } from './routes/_authenticated/$mallId/coupon/new'
import { Route as AuthenticatedMallIdCouponEventIdRouteImport } from './routes/_authenticated/$mallId/coupon/$eventId'
import { Route as AuthenticatedMallIdBillingCallbackRouteImport } from './routes/_authenticated/$mallId/billing/callback'
import { Route as AuthenticatedMallIdAutomationNewRouteImport } from './routes/_authenticated/$mallId/automation/new'
import { Route as AuthenticatedMallIdAutomationRuleIdRouteImport } from './routes/_authenticated/$mallId/automation/$ruleId'
import { Route as AuthenticatedMallIdAnalysisRfmIndexRouteImport } from './routes/_authenticated/$mallId/analysis/rfm/index'
import { Route as AuthenticatedMallIdAnalysisPurchaseCycleIndexRouteImport } from './routes/_authenticated/$mallId/analysis/purchase-cycle/index'
import { Route as AuthenticatedMallIdAnalysisLtvIndexRouteImport } from './routes/_authenticated/$mallId/analysis/ltv/index'
import { Route as AuthenticatedMallIdAnalysisCouponPerformanceIndexRouteImport } from './routes/_authenticated/$mallId/analysis/coupon-performance/index'
import { Route as AuthenticatedMallIdAnalysisCohortIndexRouteImport } from './routes/_authenticated/$mallId/analysis/cohort/index'

const ThemeTestRoute = ThemeTestRouteImport.update({
  id: '/theme-test',
  path: '/theme-test',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestRoute = GuestRouteImport.update({
  id: '/_guest',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const GuestSignupRoute = GuestSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => GuestRoute,
} as any)
const GuestResetPasswordRoute = GuestResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => GuestRoute,
} as any)
const GuestLoginRoute = GuestLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => GuestRoute,
} as any)
const GuestForgotPasswordRoute = GuestForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => GuestRoute,
} as any)
const AuthenticatedMallIdRoute = AuthenticatedMallIdRouteImport.update({
  id: '/$mallId',
  path: '/$mallId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedMallIdIndexRoute =
  AuthenticatedMallIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdSettingsRoute =
  AuthenticatedMallIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdReleaseNotesRoute =
  AuthenticatedMallIdReleaseNotesRouteImport.update({
    id: '/release-notes',
    path: '/release-notes',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdSupportIndexRoute =
  AuthenticatedMallIdSupportIndexRouteImport.update({
    id: '/support/',
    path: '/support/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdCouponIndexRoute =
  AuthenticatedMallIdCouponIndexRouteImport.update({
    id: '/coupon/',
    path: '/coupon/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdBillingIndexRoute =
  AuthenticatedMallIdBillingIndexRouteImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAutomationIndexRoute =
  AuthenticatedMallIdAutomationIndexRouteImport.update({
    id: '/automation/',
    path: '/automation/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdSupportInquiryIdRoute =
  AuthenticatedMallIdSupportInquiryIdRouteImport.update({
    id: '/support/$inquiryId',
    path: '/support/$inquiryId',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdCouponNewRoute =
  AuthenticatedMallIdCouponNewRouteImport.update({
    id: '/coupon/new',
    path: '/coupon/new',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdCouponEventIdRoute =
  AuthenticatedMallIdCouponEventIdRouteImport.update({
    id: '/coupon/$eventId',
    path: '/coupon/$eventId',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdBillingCallbackRoute =
  AuthenticatedMallIdBillingCallbackRouteImport.update({
    id: '/billing/callback',
    path: '/billing/callback',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAutomationNewRoute =
  AuthenticatedMallIdAutomationNewRouteImport.update({
    id: '/automation/new',
    path: '/automation/new',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAutomationRuleIdRoute =
  AuthenticatedMallIdAutomationRuleIdRouteImport.update({
    id: '/automation/$ruleId',
    path: '/automation/$ruleId',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAnalysisRfmIndexRoute =
  AuthenticatedMallIdAnalysisRfmIndexRouteImport.update({
    id: '/analysis/rfm/',
    path: '/analysis/rfm/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute =
  AuthenticatedMallIdAnalysisPurchaseCycleIndexRouteImport.update({
    id: '/analysis/purchase-cycle/',
    path: '/analysis/purchase-cycle/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAnalysisLtvIndexRoute =
  AuthenticatedMallIdAnalysisLtvIndexRouteImport.update({
    id: '/analysis/ltv/',
    path: '/analysis/ltv/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute =
  AuthenticatedMallIdAnalysisCouponPerformanceIndexRouteImport.update({
    id: '/analysis/coupon-performance/',
    path: '/analysis/coupon-performance/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)
const AuthenticatedMallIdAnalysisCohortIndexRoute =
  AuthenticatedMallIdAnalysisCohortIndexRouteImport.update({
    id: '/analysis/cohort/',
    path: '/analysis/cohort/',
    getParentRoute: () => AuthenticatedMallIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/theme-test': typeof ThemeTestRoute
  '/$mallId': typeof AuthenticatedMallIdRouteWithChildren
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/signup': typeof GuestSignupRoute
  '/$mallId/release-notes': typeof AuthenticatedMallIdReleaseNotesRoute
  '/$mallId/settings': typeof AuthenticatedMallIdSettingsRoute
  '/$mallId/': typeof AuthenticatedMallIdIndexRoute
  '/$mallId/automation/$ruleId': typeof AuthenticatedMallIdAutomationRuleIdRoute
  '/$mallId/automation/new': typeof AuthenticatedMallIdAutomationNewRoute
  '/$mallId/billing/callback': typeof AuthenticatedMallIdBillingCallbackRoute
  '/$mallId/coupon/$eventId': typeof AuthenticatedMallIdCouponEventIdRoute
  '/$mallId/coupon/new': typeof AuthenticatedMallIdCouponNewRoute
  '/$mallId/support/$inquiryId': typeof AuthenticatedMallIdSupportInquiryIdRoute
  '/$mallId/automation/': typeof AuthenticatedMallIdAutomationIndexRoute
  '/$mallId/billing/': typeof AuthenticatedMallIdBillingIndexRoute
  '/$mallId/coupon/': typeof AuthenticatedMallIdCouponIndexRoute
  '/$mallId/support/': typeof AuthenticatedMallIdSupportIndexRoute
  '/$mallId/analysis/cohort/': typeof AuthenticatedMallIdAnalysisCohortIndexRoute
  '/$mallId/analysis/coupon-performance/': typeof AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute
  '/$mallId/analysis/ltv/': typeof AuthenticatedMallIdAnalysisLtvIndexRoute
  '/$mallId/analysis/purchase-cycle/': typeof AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute
  '/$mallId/analysis/rfm/': typeof AuthenticatedMallIdAnalysisRfmIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/theme-test': typeof ThemeTestRoute
  '/forgot-password': typeof GuestForgotPasswordRoute
  '/login': typeof GuestLoginRoute
  '/reset-password': typeof GuestResetPasswordRoute
  '/signup': typeof GuestSignupRoute
  '/$mallId/release-notes': typeof AuthenticatedMallIdReleaseNotesRoute
  '/$mallId/settings': typeof AuthenticatedMallIdSettingsRoute
  '/$mallId': typeof AuthenticatedMallIdIndexRoute
  '/$mallId/automation/$ruleId': typeof AuthenticatedMallIdAutomationRuleIdRoute
  '/$mallId/automation/new': typeof AuthenticatedMallIdAutomationNewRoute
  '/$mallId/billing/callback': typeof AuthenticatedMallIdBillingCallbackRoute
  '/$mallId/coupon/$eventId': typeof AuthenticatedMallIdCouponEventIdRoute
  '/$mallId/coupon/new': typeof AuthenticatedMallIdCouponNewRoute
  '/$mallId/support/$inquiryId': typeof AuthenticatedMallIdSupportInquiryIdRoute
  '/$mallId/automation': typeof AuthenticatedMallIdAutomationIndexRoute
  '/$mallId/billing': typeof AuthenticatedMallIdBillingIndexRoute
  '/$mallId/coupon': typeof AuthenticatedMallIdCouponIndexRoute
  '/$mallId/support': typeof AuthenticatedMallIdSupportIndexRoute
  '/$mallId/analysis/cohort': typeof AuthenticatedMallIdAnalysisCohortIndexRoute
  '/$mallId/analysis/coupon-performance': typeof AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute
  '/$mallId/analysis/ltv': typeof AuthenticatedMallIdAnalysisLtvIndexRoute
  '/$mallId/analysis/purchase-cycle': typeof AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute
  '/$mallId/analysis/rfm': typeof AuthenticatedMallIdAnalysisRfmIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_guest': typeof GuestRouteWithChildren
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms': typeof TermsRoute
  '/theme-test': typeof ThemeTestRoute
  '/_authenticated/$mallId': typeof AuthenticatedMallIdRouteWithChildren
  '/_guest/forgot-password': typeof GuestForgotPasswordRoute
  '/_guest/login': typeof GuestLoginRoute
  '/_guest/reset-password': typeof GuestResetPasswordRoute
  '/_guest/signup': typeof GuestSignupRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/$mallId/release-notes': typeof AuthenticatedMallIdReleaseNotesRoute
  '/_authenticated/$mallId/settings': typeof AuthenticatedMallIdSettingsRoute
  '/_authenticated/$mallId/': typeof AuthenticatedMallIdIndexRoute
  '/_authenticated/$mallId/automation/$ruleId': typeof AuthenticatedMallIdAutomationRuleIdRoute
  '/_authenticated/$mallId/automation/new': typeof AuthenticatedMallIdAutomationNewRoute
  '/_authenticated/$mallId/billing/callback': typeof AuthenticatedMallIdBillingCallbackRoute
  '/_authenticated/$mallId/coupon/$eventId': typeof AuthenticatedMallIdCouponEventIdRoute
  '/_authenticated/$mallId/coupon/new': typeof AuthenticatedMallIdCouponNewRoute
  '/_authenticated/$mallId/support/$inquiryId': typeof AuthenticatedMallIdSupportInquiryIdRoute
  '/_authenticated/$mallId/automation/': typeof AuthenticatedMallIdAutomationIndexRoute
  '/_authenticated/$mallId/billing/': typeof AuthenticatedMallIdBillingIndexRoute
  '/_authenticated/$mallId/coupon/': typeof AuthenticatedMallIdCouponIndexRoute
  '/_authenticated/$mallId/support/': typeof AuthenticatedMallIdSupportIndexRoute
  '/_authenticated/$mallId/analysis/cohort/': typeof AuthenticatedMallIdAnalysisCohortIndexRoute
  '/_authenticated/$mallId/analysis/coupon-performance/': typeof AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute
  '/_authenticated/$mallId/analysis/ltv/': typeof AuthenticatedMallIdAnalysisLtvIndexRoute
  '/_authenticated/$mallId/analysis/purchase-cycle/': typeof AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute
  '/_authenticated/$mallId/analysis/rfm/': typeof AuthenticatedMallIdAnalysisRfmIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/privacy-policy'
    | '/terms'
    | '/theme-test'
    | '/$mallId'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/$mallId/release-notes'
    | '/$mallId/settings'
    | '/$mallId/'
    | '/$mallId/automation/$ruleId'
    | '/$mallId/automation/new'
    | '/$mallId/billing/callback'
    | '/$mallId/coupon/$eventId'
    | '/$mallId/coupon/new'
    | '/$mallId/support/$inquiryId'
    | '/$mallId/automation/'
    | '/$mallId/billing/'
    | '/$mallId/coupon/'
    | '/$mallId/support/'
    | '/$mallId/analysis/cohort/'
    | '/$mallId/analysis/coupon-performance/'
    | '/$mallId/analysis/ltv/'
    | '/$mallId/analysis/purchase-cycle/'
    | '/$mallId/analysis/rfm/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/privacy-policy'
    | '/terms'
    | '/theme-test'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/$mallId/release-notes'
    | '/$mallId/settings'
    | '/$mallId'
    | '/$mallId/automation/$ruleId'
    | '/$mallId/automation/new'
    | '/$mallId/billing/callback'
    | '/$mallId/coupon/$eventId'
    | '/$mallId/coupon/new'
    | '/$mallId/support/$inquiryId'
    | '/$mallId/automation'
    | '/$mallId/billing'
    | '/$mallId/coupon'
    | '/$mallId/support'
    | '/$mallId/analysis/cohort'
    | '/$mallId/analysis/coupon-performance'
    | '/$mallId/analysis/ltv'
    | '/$mallId/analysis/purchase-cycle'
    | '/$mallId/analysis/rfm'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_guest'
    | '/privacy-policy'
    | '/terms'
    | '/theme-test'
    | '/_authenticated/$mallId'
    | '/_guest/forgot-password'
    | '/_guest/login'
    | '/_guest/reset-password'
    | '/_guest/signup'
    | '/_authenticated/'
    | '/_authenticated/$mallId/release-notes'
    | '/_authenticated/$mallId/settings'
    | '/_authenticated/$mallId/'
    | '/_authenticated/$mallId/automation/$ruleId'
    | '/_authenticated/$mallId/automation/new'
    | '/_authenticated/$mallId/billing/callback'
    | '/_authenticated/$mallId/coupon/$eventId'
    | '/_authenticated/$mallId/coupon/new'
    | '/_authenticated/$mallId/support/$inquiryId'
    | '/_authenticated/$mallId/automation/'
    | '/_authenticated/$mallId/billing/'
    | '/_authenticated/$mallId/coupon/'
    | '/_authenticated/$mallId/support/'
    | '/_authenticated/$mallId/analysis/cohort/'
    | '/_authenticated/$mallId/analysis/coupon-performance/'
    | '/_authenticated/$mallId/analysis/ltv/'
    | '/_authenticated/$mallId/analysis/purchase-cycle/'
    | '/_authenticated/$mallId/analysis/rfm/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  GuestRoute: typeof GuestRouteWithChildren
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsRoute: typeof TermsRoute
  ThemeTestRoute: typeof ThemeTestRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/theme-test': {
      id: '/theme-test'
      path: '/theme-test'
      fullPath: '/theme-test'
      preLoaderRoute: typeof ThemeTestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_guest': {
      id: '/_guest'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof GuestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_guest/signup': {
      id: '/_guest/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof GuestSignupRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/reset-password': {
      id: '/_guest/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof GuestResetPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/login': {
      id: '/_guest/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof GuestLoginRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_guest/forgot-password': {
      id: '/_guest/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof GuestForgotPasswordRouteImport
      parentRoute: typeof GuestRoute
    }
    '/_authenticated/$mallId': {
      id: '/_authenticated/$mallId'
      path: '/$mallId'
      fullPath: '/$mallId'
      preLoaderRoute: typeof AuthenticatedMallIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/$mallId/': {
      id: '/_authenticated/$mallId/'
      path: '/'
      fullPath: '/$mallId/'
      preLoaderRoute: typeof AuthenticatedMallIdIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/settings': {
      id: '/_authenticated/$mallId/settings'
      path: '/settings'
      fullPath: '/$mallId/settings'
      preLoaderRoute: typeof AuthenticatedMallIdSettingsRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/release-notes': {
      id: '/_authenticated/$mallId/release-notes'
      path: '/release-notes'
      fullPath: '/$mallId/release-notes'
      preLoaderRoute: typeof AuthenticatedMallIdReleaseNotesRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/support/': {
      id: '/_authenticated/$mallId/support/'
      path: '/support'
      fullPath: '/$mallId/support/'
      preLoaderRoute: typeof AuthenticatedMallIdSupportIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/coupon/': {
      id: '/_authenticated/$mallId/coupon/'
      path: '/coupon'
      fullPath: '/$mallId/coupon/'
      preLoaderRoute: typeof AuthenticatedMallIdCouponIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/billing/': {
      id: '/_authenticated/$mallId/billing/'
      path: '/billing'
      fullPath: '/$mallId/billing/'
      preLoaderRoute: typeof AuthenticatedMallIdBillingIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/automation/': {
      id: '/_authenticated/$mallId/automation/'
      path: '/automation'
      fullPath: '/$mallId/automation/'
      preLoaderRoute: typeof AuthenticatedMallIdAutomationIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/support/$inquiryId': {
      id: '/_authenticated/$mallId/support/$inquiryId'
      path: '/support/$inquiryId'
      fullPath: '/$mallId/support/$inquiryId'
      preLoaderRoute: typeof AuthenticatedMallIdSupportInquiryIdRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/coupon/new': {
      id: '/_authenticated/$mallId/coupon/new'
      path: '/coupon/new'
      fullPath: '/$mallId/coupon/new'
      preLoaderRoute: typeof AuthenticatedMallIdCouponNewRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/coupon/$eventId': {
      id: '/_authenticated/$mallId/coupon/$eventId'
      path: '/coupon/$eventId'
      fullPath: '/$mallId/coupon/$eventId'
      preLoaderRoute: typeof AuthenticatedMallIdCouponEventIdRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/billing/callback': {
      id: '/_authenticated/$mallId/billing/callback'
      path: '/billing/callback'
      fullPath: '/$mallId/billing/callback'
      preLoaderRoute: typeof AuthenticatedMallIdBillingCallbackRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/automation/new': {
      id: '/_authenticated/$mallId/automation/new'
      path: '/automation/new'
      fullPath: '/$mallId/automation/new'
      preLoaderRoute: typeof AuthenticatedMallIdAutomationNewRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/automation/$ruleId': {
      id: '/_authenticated/$mallId/automation/$ruleId'
      path: '/automation/$ruleId'
      fullPath: '/$mallId/automation/$ruleId'
      preLoaderRoute: typeof AuthenticatedMallIdAutomationRuleIdRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/analysis/rfm/': {
      id: '/_authenticated/$mallId/analysis/rfm/'
      path: '/analysis/rfm'
      fullPath: '/$mallId/analysis/rfm/'
      preLoaderRoute: typeof AuthenticatedMallIdAnalysisRfmIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/analysis/purchase-cycle/': {
      id: '/_authenticated/$mallId/analysis/purchase-cycle/'
      path: '/analysis/purchase-cycle'
      fullPath: '/$mallId/analysis/purchase-cycle/'
      preLoaderRoute: typeof AuthenticatedMallIdAnalysisPurchaseCycleIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/analysis/ltv/': {
      id: '/_authenticated/$mallId/analysis/ltv/'
      path: '/analysis/ltv'
      fullPath: '/$mallId/analysis/ltv/'
      preLoaderRoute: typeof AuthenticatedMallIdAnalysisLtvIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/analysis/coupon-performance/': {
      id: '/_authenticated/$mallId/analysis/coupon-performance/'
      path: '/analysis/coupon-performance'
      fullPath: '/$mallId/analysis/coupon-performance/'
      preLoaderRoute: typeof AuthenticatedMallIdAnalysisCouponPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
    '/_authenticated/$mallId/analysis/cohort/': {
      id: '/_authenticated/$mallId/analysis/cohort/'
      path: '/analysis/cohort'
      fullPath: '/$mallId/analysis/cohort/'
      preLoaderRoute: typeof AuthenticatedMallIdAnalysisCohortIndexRouteImport
      parentRoute: typeof AuthenticatedMallIdRoute
    }
  }
}

interface AuthenticatedMallIdRouteChildren {
  AuthenticatedMallIdReleaseNotesRoute: typeof AuthenticatedMallIdReleaseNotesRoute
  AuthenticatedMallIdSettingsRoute: typeof AuthenticatedMallIdSettingsRoute
  AuthenticatedMallIdIndexRoute: typeof AuthenticatedMallIdIndexRoute
  AuthenticatedMallIdAutomationRuleIdRoute: typeof AuthenticatedMallIdAutomationRuleIdRoute
  AuthenticatedMallIdAutomationNewRoute: typeof AuthenticatedMallIdAutomationNewRoute
  AuthenticatedMallIdBillingCallbackRoute: typeof AuthenticatedMallIdBillingCallbackRoute
  AuthenticatedMallIdCouponEventIdRoute: typeof AuthenticatedMallIdCouponEventIdRoute
  AuthenticatedMallIdCouponNewRoute: typeof AuthenticatedMallIdCouponNewRoute
  AuthenticatedMallIdSupportInquiryIdRoute: typeof AuthenticatedMallIdSupportInquiryIdRoute
  AuthenticatedMallIdAutomationIndexRoute: typeof AuthenticatedMallIdAutomationIndexRoute
  AuthenticatedMallIdBillingIndexRoute: typeof AuthenticatedMallIdBillingIndexRoute
  AuthenticatedMallIdCouponIndexRoute: typeof AuthenticatedMallIdCouponIndexRoute
  AuthenticatedMallIdSupportIndexRoute: typeof AuthenticatedMallIdSupportIndexRoute
  AuthenticatedMallIdAnalysisCohortIndexRoute: typeof AuthenticatedMallIdAnalysisCohortIndexRoute
  AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute: typeof AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute
  AuthenticatedMallIdAnalysisLtvIndexRoute: typeof AuthenticatedMallIdAnalysisLtvIndexRoute
  AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute: typeof AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute
  AuthenticatedMallIdAnalysisRfmIndexRoute: typeof AuthenticatedMallIdAnalysisRfmIndexRoute
}

const AuthenticatedMallIdRouteChildren: AuthenticatedMallIdRouteChildren = {
  AuthenticatedMallIdReleaseNotesRoute: AuthenticatedMallIdReleaseNotesRoute,
  AuthenticatedMallIdSettingsRoute: AuthenticatedMallIdSettingsRoute,
  AuthenticatedMallIdIndexRoute: AuthenticatedMallIdIndexRoute,
  AuthenticatedMallIdAutomationRuleIdRoute:
    AuthenticatedMallIdAutomationRuleIdRoute,
  AuthenticatedMallIdAutomationNewRoute: AuthenticatedMallIdAutomationNewRoute,
  AuthenticatedMallIdBillingCallbackRoute:
    AuthenticatedMallIdBillingCallbackRoute,
  AuthenticatedMallIdCouponEventIdRoute: AuthenticatedMallIdCouponEventIdRoute,
  AuthenticatedMallIdCouponNewRoute: AuthenticatedMallIdCouponNewRoute,
  AuthenticatedMallIdSupportInquiryIdRoute:
    AuthenticatedMallIdSupportInquiryIdRoute,
  AuthenticatedMallIdAutomationIndexRoute:
    AuthenticatedMallIdAutomationIndexRoute,
  AuthenticatedMallIdBillingIndexRoute: AuthenticatedMallIdBillingIndexRoute,
  AuthenticatedMallIdCouponIndexRoute: AuthenticatedMallIdCouponIndexRoute,
  AuthenticatedMallIdSupportIndexRoute: AuthenticatedMallIdSupportIndexRoute,
  AuthenticatedMallIdAnalysisCohortIndexRoute:
    AuthenticatedMallIdAnalysisCohortIndexRoute,
  AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute:
    AuthenticatedMallIdAnalysisCouponPerformanceIndexRoute,
  AuthenticatedMallIdAnalysisLtvIndexRoute:
    AuthenticatedMallIdAnalysisLtvIndexRoute,
  AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute:
    AuthenticatedMallIdAnalysisPurchaseCycleIndexRoute,
  AuthenticatedMallIdAnalysisRfmIndexRoute:
    AuthenticatedMallIdAnalysisRfmIndexRoute,
}

const AuthenticatedMallIdRouteWithChildren =
  AuthenticatedMallIdRoute._addFileChildren(AuthenticatedMallIdRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedMallIdRoute: typeof AuthenticatedMallIdRouteWithChildren
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedMallIdRoute: AuthenticatedMallIdRouteWithChildren,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface GuestRouteChildren {
  GuestForgotPasswordRoute: typeof GuestForgotPasswordRoute
  GuestLoginRoute: typeof GuestLoginRoute
  GuestResetPasswordRoute: typeof GuestResetPasswordRoute
  GuestSignupRoute: typeof GuestSignupRoute
}

const GuestRouteChildren: GuestRouteChildren = {
  GuestForgotPasswordRoute: GuestForgotPasswordRoute,
  GuestLoginRoute: GuestLoginRoute,
  GuestResetPasswordRoute: GuestResetPasswordRoute,
  GuestSignupRoute: GuestSignupRoute,
}

const GuestRouteWithChildren = GuestRoute._addFileChildren(GuestRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  GuestRoute: GuestRouteWithChildren,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsRoute: TermsRoute,
  ThemeTestRoute: ThemeTestRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
